import { FieldType } from '@wix/wix-data-schema-types'
import {
  BUTTON_ROLE,
  BUTTON_ROLE_LINK_SUBROLE,
  BUTTON_ROLE_LINK_LABEL_SUBROLE,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const {
  document,
  url,
  image,
  video,
  audio,
  text,
  number,
  address,
  stringArray,
  dateTime,
  date,
  color,
} = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Button',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  compactErrorPanel: false,
  panel: {
    height: 509,
    title: 'Connect_Panel_Title_Button',
    helpId: 'f3e95690-e2c0-4172-bd5f-f6b77335279d',
  },
  sections: [
    {
      role: BUTTON_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Link_Action',
          prop: 'link',
          event: 'onClick',
          supportedFieldTypes: [document, url, image, video, audio],
          defaultFieldType: url,
          supportPageLinks: true,
          supportsActions: true,
          supportsReferenceFields: true,
          supportsPostSubmit: true,
          supportsUrlTarget: true,
          supportsUrlRel: true,
          requiresPrimaryConnection: true,
        },
        {
          title: 'Connect_Panel_Connect_Label_Label',
          prop: 'label',
          supportedFieldTypes: [
            text,
            number,
            dateTime,
            date,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },

        {
          title: 'connectButtonPanel.accessibleNameBinding.title',
          prop: 'accessibility.ariaLabel',
          supportedFieldTypes: [
            text,
            number,
            dateTime,
            date,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },

        {
          title: 'Connect_Panel_Connect_Button_Color',
          prop: 'style.color',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
        {
          title: 'Connect_Panel_Connect_Button_Icon_Color',
          prop: 'style.iconColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: ['wixui.StylableButton'],
        },
        {
          title: 'Connect_Panel_Connect_Button_Border_Color',
          prop: 'style.borderColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
        {
          title: 'Connect_Panel_Connect_Button_Background_Color',
          prop: 'style.backgroundColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
        {
          title: 'Connect_Panel_Connect_Button_Color',
          prop: 'style.hover.color',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
        {
          title: 'Connect_Panel_Connect_Button_Icon_Color',
          prop: 'style.hover.iconColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: ['wixui.StylableButton'],
        },
        {
          title: 'Connect_Panel_Connect_Button_Border_Color',
          prop: 'style.hover.borderColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
        {
          title: 'Connect_Panel_Connect_Button_Background_Color',
          prop: 'style.hover.backgroundColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
        {
          title: 'Connect_Panel_Connect_Button_Color',
          prop: 'style.disabled.color',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
        {
          title: 'Connect_Panel_Connect_Button_Icon_Color',
          prop: 'style.disabled.iconColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: ['wixui.StylableButton'],
        },
        {
          title: 'Connect_Panel_Connect_Button_Border_Color',
          prop: 'style.disabled.borderColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
        {
          title: 'Connect_Panel_Connect_Button_Background_Color',
          prop: 'style.disabled.backgroundColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
          supportedViewerTypes: [
            'wysiwyg.viewer.components.SiteButton',
            'wixui.StylableButton',
          ],
        },
      ],
      subroles: [
        {
          name: BUTTON_ROLE_LINK_LABEL_SUBROLE,
          conditions: [
            {
              connectedProps: [{ prop: 'link' }, { prop: 'label' }],
            },
            {
              connectedProps: [{ prop: 'label' }],
              connectedEvents: [{ prop: 'link', event: 'onClick' as const }],
            },
          ],
          manifest: {
            gfpp: {
              desktop: {
                iconButtons: {
                  link: {
                    behavior: 'HIDE' as const,
                  },
                },
              },
            },
            panel: {
              settings: {
                controls: {
                  link: { hidden: true },
                },
              },
            },
          },
        },
        {
          name: BUTTON_ROLE_LINK_SUBROLE,
          conditions: [
            {
              connectedProps: [{ prop: 'link' }],
            },
            {
              connectedEvents: [{ prop: 'link', event: 'onClick' as const }],
            },
          ],
          manifest: {
            gfpp: {
              desktop: {
                iconButtons: {
                  link: {
                    behavior: 'HIDE' as const,
                  },
                },
              },
            },
            panel: {
              settings: {
                controls: {
                  link: { hidden: true },
                },
              },
            },
          },
        },
      ],
    },
  ],
})
